import { render, staticRenderFns } from "./AssetStatus.vue?vue&type=template&id=398bec80&scoped=true&"
import script from "./AssetStatus.vue?vue&type=script&lang=ts&"
export * from "./AssetStatus.vue?vue&type=script&lang=ts&"
import style0 from "./AssetStatus.vue?vue&type=style&index=0&id=398bec80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398bec80",
  null
  
)

export default component.exports